import { openDB } from 'idb'
import log from './useLogger'

export interface UserSettingsLocal {
  user_id: string
  settings: Record<string, any>
  version: number
  updated_at: string
}

const dbName = 'idi-fly-dashboard-v3'
const dbVersion = 1

export const getDb = async (storeName: string) => {
  return await openDB(dbName, dbVersion, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'user_id' })
      }
    },
  })
}
export const saveUserSettingsLocal = async (
  user_id: string,
  settings: Record<string, any>,
  version: number,
  updated_at: string,
) => {
  const db = await getDb('userSettings')
  const record: UserSettingsLocal = { user_id, settings, version, updated_at }
  await db.put('userSettings', record)
  return record
}

export const getUserSettings = async (user_id: string): Promise<UserSettingsLocal | undefined> => {
  const db = await getDb('userSettings')
  log.info('Getting user settings for user_id:', user_id)
  return await db.get('userSettings', user_id)
}
export const deleteUserSettings = async (user_id: string) => {
  const db = await getDb('userSettings')
  return db.delete('userSettings', user_id)
}
